import {NewScheduledReportButton} from "@/pages/reports/schedule/NewScheduledReportButton.tsx";

export const ScheduleReportActions = () => {
  return (
    <div>
      <NewScheduledReportButton />
    </div>
  );
};
